import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { UsageTypeReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class UsageTypeReferenceService extends ApiServiceBase {
    readonly REFERENCE_PATH = '/system/usageTypeReferences';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getUsageTypeReferences(): Observable<UsageTypeReferenceModel[]> {
        return this.httpGet<UsageTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(
                    res => res.body
                )
            )
    }
}